export const A4_METRICS = {
	pageWidth: 793,
	pageHeight: 1122,
	marginTop: 83,
	marginRight: 94,
	marginBottom: 102,
	marginLeft: 94,
};

export const A4_USABLE_HEIGHT =
	A4_METRICS.pageHeight - A4_METRICS.marginTop - A4_METRICS.marginBottom;

export interface MeasuredBlock {
	height: number;
	forcedBreak: boolean;
	marginTop: number;
	marginBottom: number;
	keepWithNext?: boolean;
}

export function pageFlowHeight(blocks: MeasuredBlock[]): number {
	let total = 0;
	let prevBottom = 0;

	for (const [index, block] of blocks.entries()) {
		total += (index === 0 ? block.marginTop : Math.max(prevBottom, block.marginTop)) + block.height;
		prevBottom = block.marginBottom;
	}

	return total + prevBottom;
}

export function paginate(
	items: MeasuredBlock[],
	usableHeight = A4_USABLE_HEIGHT,
	options?: { guardOversized?: boolean },
): number[][] {
	const pages: number[][] = [];
	let current: number[] = [];
	let used = 0;
	let prevBottom = 0;
	let empty = true;

	const close = () => {
		if (current.length > 0) {
			pages.push(current);
			current = [];
			used = 0;
			prevBottom = 0;
			empty = true;
		}
	};

	const place = (index: number) => {
		const item = items[index];

		used += (empty ? item.marginTop : Math.max(prevBottom, item.marginTop)) + item.height;
		current.push(index);
		prevBottom = item.marginBottom;
		empty = false;
	};

	const overflowClose = () => {
		let keep = current.length;

		while (keep > 0 && items[current[keep - 1]].keepWithNext === true) {
			keep -= 1;
		}

		if (keep === 0 || keep === current.length) {
			close();

			return;
		}

		const moved = current.slice(keep);
		current = current.slice(0, keep);

		close();

		for (const index of moved) {
			place(index);
		}
	};

	for (const [index, item] of items.entries()) {
		if (item.forcedBreak) {
			close();

			continue;
		}

		if (options?.guardOversized === true && item.height > usableHeight) {
			throw new Error("oversized_document_block");
		}

		const overflows = () => {
			const lead = empty ? item.marginTop : Math.max(prevBottom, item.marginTop);

			return !empty && used + lead + item.height + item.marginBottom > usableHeight;
		};

		if (overflows()) {
			overflowClose();
		}

		if (overflows()) {
			close();
		}

		place(index);
	}

	close();

	if (pages.length === 0) {
		pages.push([]);
	}

	return pages;
}
